import type { DomNode, DomParser } from './types';

export const legacyComponentsMapCreator = ($: DomParser) => ({
	table: ($node: DomNode) => {
		if (!$node.is('table')) {
			return;
		}
		const headings = $node
			.find('tr:first')
			.find('th, td')
			.toArray()
			.map((data: unknown) => $(data).html());
		const rows = $node
			.find('tr:gt(0)')
			.toArray()
			.map((row: unknown) =>
				$(row)
					.find('td')
					.toArray()
					.map((data: unknown) => $(data).html())
			);
		return {
			columns: headings.length,
			rows: rows.length,
			headings,
			cells: rows,
		};
	},
	image: ($node: DomNode) => {
		if ($node.is('img')) {
			return { src: $node.attr('src'), align: 'left', link: '' };
		}
		if ($node.children().length === 1 && $node.find('img').length === 1) {
			return { src: $node.find('img').attr('src'), align: 'left', link: '' };
		}
		return;
	},
	iframe: ($node: DomNode) => {
		if (!$node.is('iframe')) {
			return;
		}
		const src: string = $node.attr('src');
		const width = parseInt($node.css('width'), 10) || parseInt($node.attr('width'), 10) || 500;
		const height = parseInt($node.css('height'), 10) || parseInt($node.attr('height'), 10) || 500;
		const scrolling = $node.attr('scrolling') || 'auto';
		if (!src.match(/youtube.com/) && !src.match(/vimeo.com/)) {
			return { url: src, width, height, align: 'left', scrolling };
		}
		return;
	},
	video: ($node: DomNode) => {
		if (!$node.is('iframe')) {
			return;
		}
		const width = parseInt($node.css('width'), 10) || parseInt($node.attr('width'), 10) || 500;
		const height = parseInt($node.css('height'), 10) || parseInt($node.attr('height'), 10) || 500;
		const src: string = $node.attr('src');
		if (src.match(/youtube.com/) || src.match(/vimeo.com/)) {
			return { url: src, width, height, align: 'left' };
		}
		return;
	},
	code: (_$node: DomNode) => {
		// todo
	},
	anchor: ($node: DomNode) => {
		if (!$node.is('.kb-anchor')) {
			return;
		}
		const text: string = $node.text();
		const id =
			$node.attr('id') ||
			text
				.trim()
				.replace(/['"#!.@$,%^\\&*?()[\]\-+=:/;{}~`]/gi, '')
				.replace(/&nbsp;/g, '')
				.replace(/\s/g, '-')
				.substr(0, 25)
				.toLowerCase() + (Math.random() * 200).toFixed(0);
		return { text, id };
	},
	note: ($node: DomNode) => {
		if (!$node.is('.kb-note')) {
			return;
		}
		return { html: $node.html() };
	},
	tip: ($node: DomNode) => {
		if (!$node.is('.kb-tip')) {
			return;
		}
		return { html: $node.html() };
	},
	important: ($node: DomNode) => {
		if (!$node.is('.kb-important')) {
			return;
		}
		return { html: $node.html() };
	},
	'step-by-step': ($node: DomNode) => {
		if (!$node.is('.step-by-step-widget')) {
			return;
		}
		const steps = $node
			.children('.step')
			.toArray()
			.map((step: unknown) => {
				const $step = $(step);
				return {
					html: $step.find('.description').html(),
					imageSrc: $step.find('img').attr('src'),
				};
			});
		return {
			steps,
			layout: 'dots',
			allowCircular: $node.attr('data-allow-circular') === 'true',
		};
	},
});
